<template>
  <app-modal
    :modal-id="modalId"
    modal-alignment="top"
    modal-size="large"
    @close-modal="closeModal"
  >
    <template slot="header">
      <h5 class="modal-title text-capitalize">{{ modalTitle }}</h5>
      <button
        v-if="active === 1"
        type="button"
        class="btn btn-primary text-capitalize"
        @click.prevent="addNew()"
      >
        Add {{ type }}
        
        <!-- <span>
          <app-icon :name="'x'"></app-icon>
        </span> -->
      </button>
    </template>
    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <div v-if="this.active != 1" class="mb-2">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item v-if="this.active < 3"> <a href="" @click.prevent="previous">List</a></el-breadcrumb-item>
          <el-breadcrumb-item>{{ modalTitle }}</el-breadcrumb-item>
          <!-- <el-breadcrumb-item v-if="statusCheck" ><h5 :class="statusCheck == '1' ? 'text-success' : 'text-warning'">{{statusCheck == '1' ? 'Approved' : 'Pending'}}</h5></el-breadcrumb-item> -->

        </el-breadcrumb>
    </div>
      <el-form v-if="active === 1">
        <dropdown-index :type="type" @edit="editParameter"/>
      </el-form>
      <el-form v-if="active === 2">
          <form
          class="mb-0"
          :class="{ 'loading-opacity': preloader }"
          ref="form"
          :data-url="selectedUrl ? `${addurl}/${inputs.id}` : addurl"
        >
          <div class="form-group row align-items-center">
            <label for="inputs_value" class="col-sm-3 mb-0 text-capitalize">
              {{ $t("parameter") }}
            </label>
            <app-input
              id="inputs_value"
              class="col-sm-9"
              type="text"
              v-model="inputs.value"
              :required="true"
            />
          </div>
        </form>
      </el-form>
    </template>
    <template slot="footer">
      <button
        v-if="active === 1"
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        {{ $t("close") }}
      </button>
      <button
        v-if="active === 2"
        type="button"
        class="btn btn-primary mr-2"
        @click.previent="submit()"
      >
        {{ $t("save") }}
      </button>
    </template>
  </app-modal>
</template>

<script>
import { FormMixin } from "../../../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../../../Mixins/ModalMixin";
import * as actions from "../../../../../../Config/ApiUrl";
import { axiosPost} from "../../../../../../../app/Helpers/AxiosHelper";

export default {
  name: "AddModal",
  mixins: [FormMixin, ModalMixin],
  props: {
    type: String,
  },
  data() {
    return {
      active: 1,
      addurl:actions.ADD_DROPDOWN_VALUE,
      preloader: false,
      inputs: {},
      modalId: "dropdown-add-Modal",
      modalTitle: this.type +'s',
    };
  },
  methods: {
    addNew() {
      this.modalTitle = this.$t("add") + ' '+ this.type;
      this.active = 2;
    },
    previous() {
      this.active = 1;
    },
    submit() {
      this.inputs.type = this.type;
      this.save(this.inputs);
    },
    afterSuccess(response) {
      this.$toastr.s(response.data.message);
    },
    editParameter(value) {
      this.inputs.id = value.id;
      this.inputs.value = value.value;
      this.modalTitle = this.$t("edit") + ' '+ this.type;
      this.active = 2;
    }
  },

  mounted() {
    $(function () {
      $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
    });
  },
};
</script>
